import { FetchLoginRequest, FetchUserProfileRequest } from "../reducer/types";
import Constants from "expo-constants";
import { AxiosRequestConfig } from "axios";
import qs from "qs";
import appConfig from "../../../config/app-config";
import { instanceService } from "app/shared/services/axios";

export const loginService = async (action: FetchLoginRequest) => {
  const body = {
    username: action.payload.userId,
    password: action.payload.passWord,
    client_id: Constants.manifest.extra?.KEYCLOAK_CLIENTID,
    grant_type: "password",
  };
  const configRequest: AxiosRequestConfig = {
    headers: { "content-type": "application/x-www-form-urlencoded" },
  };
  return instanceService.post(appConfig.login, qs.stringify(body), configRequest);
};

export const userProfileService = async (action: FetchUserProfileRequest) => {
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${action.payload}`,
    },
  };
  return instanceService.post(appConfig.userInfoEndpoint, undefined, config);
};
